import { useCallback, useMemo } from 'react';
import {
  calculateMaxVolume,
  roundVolume,
} from '../../../common/utils/calculations.util';
import { OrderTypes } from '../../../common/constants/trading.constants';

export const useVolume = ({
  store,
  symbolProperties,
  freeMargin,
  calculateMaxVolumeDependingOnOpenAtPrice,
}) => {
  const max = useMemo(() => {
    return (
      calculateMaxVolume({
        freeMargin,
        kRate: symbolProperties.kRate,
        contractSize: symbolProperties.contractSize,
        calcMode: symbolProperties.calcMode,
        price:
          calculateMaxVolumeDependingOnOpenAtPrice && store.openAtPrice //  for pending orders calculate volume depending on 'openAtPriceOf'
            ? {
                ask: store.openAtPriceOf,
                bid: store.openAtPriceOf,
              }
            : symbolProperties.price,
        leverage: symbolProperties.leverage,
        volumeStep: symbolProperties.volumeStep,
        marginRate: symbolProperties.marginRate,
        commission: symbolProperties.commission,
      })[OrderTypes.Buy] || 0
    );
  }, [
    freeMargin,
    symbolProperties.kRate,
    symbolProperties.contractSize,
    symbolProperties.calcMode,
    symbolProperties.price,
    store.openAtPriceOf,
    store.openAtPrice,
    symbolProperties.leverage,
    symbolProperties.volumeStep,
    symbolProperties.marginRate,
    symbolProperties.commission,
    calculateMaxVolumeDependingOnOpenAtPrice,
  ]);

  const min = useMemo(
    () => symbolProperties.minVolume[OrderTypes.Buy] || 0,
    [symbolProperties.minVolume]
  );

  const onChange = useCallback(
    (value) => {
      const newLimitOfInvestment = value / max;
      if (newLimitOfInvestment <= 1) {
        store.setLimitOfInvestment(newLimitOfInvestment);
      } else store.setLimitOfInvestment(1);
    },
    [store, max]
  );

  const value = useMemo(
    () =>
      roundVolume(
        max * Math.max(store.limitOfInvestment, min / max),
        symbolProperties.volumeStep
      ),
    [min, max, symbolProperties.volumeStep, store.limitOfInvestment]
  );

  return {
    min,
    max,
    onChange,
    value,
    step: symbolProperties.volumeStep,
  };
};
